/** Register the org-media Cache Storage service worker (D12). */

const SW_URL = '/media-cache-sw.js';

export function registerMediaCacheServiceWorker(): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(SW_URL).catch(() => {
      /* registration can fail on unsupported/private contexts */
    });
  });
}
